import React from 'react';
import './ErrorSnackbar.scss';

interface ErrorSnackbarProps {
    message: string;
    show: boolean;
}

const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ message, show }) => {
    if (!show) return null;
    
    return (
        <div className="error-snackbar">
            {message}
        </div>
    );
};

export default ErrorSnackbar;